var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentoCheck24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.75C5.20507 2.75 3.75 4.20507 3.75 6V18C3.75 19.7949 5.20507 21.25 7 21.25H12C12.4142 21.25 12.75 21.5858 12.75 22C12.75 22.4142 12.4142 22.75 12 22.75H7C4.37665 22.75 2.25 20.6234 2.25 18V6C2.25 3.37665 4.37665 1.25 7 1.25H13.0633C13.8794 1.25 14.6534 1.61251 15.1759 2.23949L19.1126 6.96359C19.5245 7.45781 19.75 8.08077 19.75 8.7241V12C19.75 12.4142 19.4142 12.75 19 12.75C18.5858 12.75 18.25 12.4142 18.25 12V8.7241C18.25 8.43168 18.1475 8.14851 17.9603 7.92387L14.0235 3.19977C13.786 2.91478 13.4342 2.75 13.0633 2.75H7Z",
    fill: "#2FB699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.75C14.4142 1.75 14.75 2.08579 14.75 2.5V6C14.75 6.69036 15.3096 7.25 16 7.25H18.5C18.9142 7.25 19.25 7.58579 19.25 8C19.25 8.41421 18.9142 8.75 18.5 8.75H16C14.4812 8.75 13.25 7.51878 13.25 6V2.5C13.25 2.08579 13.5858 1.75 14 1.75Z",
    fill: "#2FB699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12Z",
    fill: "#2FB699"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 17C6.25 16.5858 6.58579 16.25 7 16.25H11C11.4142 16.25 11.75 16.5858 11.75 17C11.75 17.4142 11.4142 17.75 11 17.75H7C6.58579 17.75 6.25 17.4142 6.25 17Z",
    fill: "#2FB699"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5303 22.5303C17.2374 22.8232 16.7626 22.8232 16.4697 22.5303L13.9697 20.0303C13.6768 19.7374 13.6768 19.2626 13.9697 18.9697C14.2626 18.6768 14.7374 18.6768 15.0303 18.9697L17 20.9393L22.4697 15.4697C22.7626 15.1768 23.2374 15.1768 23.5303 15.4697C23.8232 15.7626 23.8232 16.2374 23.5303 16.5303L17.5303 22.5303Z",
    fill: "#2FB699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentoCheck24X24);
export default __webpack_public_path__ + "static/media/DOCUMENTO_CHECK_24X24.449f6324159319302523aa01a4509979.svg";
export { ForwardRef as ReactComponent };